import { MultiTabGrid } from '@components/_SiteWide/Layout/MultiTabGrid'
import { FormGrid } from '@components/DriverManagement/DriverForms/components/FormGrid/FormGrid'
import { ResponseGrid } from '@components/DriverManagement/DriverForms/components/ResponseGrid/ResponseGrid'
import React from 'react'

export function DriverFormPage() {
  const tabs = [
    {
      title: 'Responses',
      description: 'View form responses.',
      component: <ResponseGrid />,
    },
    {
      defaultActive: true,
      title: 'Forms',
      description: 'Manage Form Configuration.',
      component: <FormGrid />,
    },
  ]
  const multiGridConfig = {
    tabs,
    stickStorageKey: 'dwell-page-tab',
  }

  return <MultiTabGrid {...multiGridConfig} />
}
